module.exports = __webpack_public_path__ + "img/IGT.2f82a00.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/IGT.png
// module id = IMHc
// module chunks = 38 43